import { render, staticRenderFns } from "./KDropdownButton.vue?vue&type=template&id=6b6bfb76&"
import script from "./KDropdownButton.vue?vue&type=script&lang=js&"
export * from "./KDropdownButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports